<template>
    <div class="text-center">
        <div class="pietext">
            {{ chartdata.graphdata[0] }}{{ suffix }}
        </div>
    </div>
</template>

<script>
    export default {
        props : ['chartdata', "suffix"]
    }
</script>

<style scoped>
    .pietext{
        width : 300px;
        height: 300px;
        background-color: #00377b;
        color: white;
        font-size: 2rem;
        font-weight : bolder;
        padding-top: 120px;
        margin:0px auto;
        border-radius: 100%;

    }

    @media (max-width: 999px) {
        .pietext{
            width : 150px;
            height: 150px;
            font-size: 1rem;
            padding-top: 60px;
            margin:0px auto;
        }
    }
</style>